import React from "react";
import Cookies from "js-cookie";
import "../theme/theme_bbtec.css";

export default function ThemeProvider({ children }) {
  const Theme = {
    1: "",
    2: "",
    3: "bbtec-theme",
  };
  return (
    <div className={Theme[Number(Cookies.get("companyid"))]}>{children}</div>
  );
}
